import Badge from "components/base/Badge";
import Button from "components/base/Button";
import { useNavigate } from "react-router-dom";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { CSSProperties, Fragment, useState } from "react";
import { pricingFeatures } from "data/landing/pricingData";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PricingItemInternal = ({ pricing, handleBuySubscription }: any) => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const handleChosePackage = (isFree: boolean) => {
    if (isFree) {
      navigate("/sign-up");
    } else {
      setShow(true);
    }
  };

  return (
    <Fragment>
      <div className="text-center pt-5">
        <img src={pricing.icon} width={48} height={48} alt="" />
        <h3 className="fw-semibold my-4">{pricing.category}</h3>
      </div>
      <div className="text-center">
        <h1 className="fw-semibold text-primary mb-4">
          $<span className="fw-bolder">{pricing.monthlyPrice}</span>
          <span className="text-body-emphasis fs-8 ms-1 fw-bolder">/month</span>
        </h1>
        <span>${pricing.yearlyPrice}/year</span>
        <div className="px-5">
          <Button
            onClick={() => handleChosePackage(pricing.isFree)}
            variant={pricing.popular ? "primary" : "outline-primary"}
            className="btn btn-lg mb-6 w-100"
          >
            {pricing.category === "Free Trial" ? "Grab" : "Buy"}
          </Button>
        </div>
      </div>
      <ul className="fa-ul pricing-list">
        {pricingFeatures.map((feature) => (
          <li key={feature.id} className="mb-4 d-flex align-items-center">
            {pricing.features.includes(feature.id) && (
              <span className="fa-li">
                <FontAwesomeIcon
                  icon={feature.icon as IconProp}
                  className="text-primary"
                />
              </span>
            )}
            <span
              className="text-body-secondary"
              style={
                pricing.features.includes(feature.id)
                  ? ({ "--phoenix-text-opacity": 1 } as CSSProperties)
                  : ({ "--phoenix-text-opacity": 0.5 } as CSSProperties)
              }
            >
              {feature.label}
            </span>
            {feature.new && (
              <Badge bg="warning" variant="phoenix" className="ms-2 fs-10">
                New
              </Badge>
            )}
          </li>
        ))}
      </ul>

      <Modal
        size="lg"
        show={show}
        centered
        backdrop="static"
        onHide={() => setShow(false)}
        contentClassName="bg-body-highlight p-6 border border-translucent"
      >
        <Modal.Header className="border-0 p-0 mb-2">
          <h3 className="mb-0">Select Interval</h3>
          <Button
            variant="phoenix-secondary"
            className="ms-auto"
            onClick={() => setShow(false)}
            size="sm"
          >
            <FontAwesomeIcon icon={faTimes} className="text-danger" />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Card className="h-100">
                <div className="text-center pt-5">
                  <img src={pricing.icon} width={48} height={48} alt="" />
                  <h3 className="fw-semibold my-4">{pricing.category}</h3>
                </div>
                <div className="text-center">
                  <h1 className="fw-semibold text-primary mb-4">
                    $<span className="fw-bolder">{pricing.monthlyPrice}</span>
                    <span className="text-body-emphasis fs-8 ms-1 fw-bolder">
                      /Month
                    </span>
                  </h1>

                  <div className="px-5">
                    <Button
                      onClick={() =>
                        handleBuySubscription(pricing.type, "month")
                      }
                      variant="outline-primary"
                      className={`btn btn-lg mb-6 w-100`}
                    >
                      Buy
                    </Button>
                  </div>
                </div>
              </Card>
            </Col>

            <Col>
              <Card className="h-100">
                <div className="text-center pt-5">
                  <img src={pricing.icon} width={48} height={48} alt="" />
                  <h3 className="fw-semibold my-4">{pricing.category}</h3>
                </div>
                <div className="text-center">
                  <h1 className="fw-semibold text-primary mb-4">
                    $<span className="fw-bolder">{pricing.yearlyPrice}</span>
                    <span className="text-body-emphasis fs-8 ms-1 fw-bolder">
                      /year
                    </span>
                  </h1>
                  <div className="px-5">
                    <Button
                      onClick={() =>
                        handleBuySubscription(pricing.type, "year")
                      }
                      variant="outline-primary"
                      className={`btn btn-lg mb-6 w-100`}
                    >
                      Buy
                    </Button>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default PricingItemInternal;
